import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button, Table, Avatar } from "tabler-react";
import ReactToPrint from "react-to-print";
import { subDays, format } from "date-fns";
import { DateRangePicker } from "react-date-range";
import useDataFetchWithPusher from "../../../effects/useDataFetchWithPusher";
import formatMoney from "../../../MoneyFormatter";
import moment from "moment";
import { formatDateForLookUp } from "../../../DateUtils";
import { getUser } from "../../../authHelper";
const DeletedPurchases = (props) => {
  const { cooperative } = getUser();
  const [dateRange, setDateRange] = useState([
    {
      startDate: subDays(new Date(), 30),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const {
    loading,
    results: purchases,
  } = useDataFetchWithPusher(
    `/inventory/purchases/deleted?limit=10000&from=${formatDateForLookUp(
      dateRange[0].startDate
    )}&to=${formatDateForLookUp(dateRange[0].endDate)}`,
    ["purchased-item-created"]
  );
  const [showDateRange, setDateRangeVisible] = useState(false);
  const componentRef = useRef();
  return (
    <Modal
      {...props}
      dialogClassName="modal-65w"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Button
          color="primary"
          icon="calendar"
          onClick={() => {
            setDateRangeVisible(!showDateRange);
          }}
        >
          {showDateRange ? "Hide date range" : "Show date range"}
        </Button>
        <ReactToPrint
          trigger={() => (
            <Button color="primary" icon="printer">
              Print
            </Button>
          )}
          content={() => componentRef.current}
        />
      </Modal.Header>
      <Modal.Body>
        <React.Fragment>
          {showDateRange && (
            <DateRangePicker
              onChange={(item) => setDateRange([item.selection])}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={dateRange}
              direction="horizontal"
            />
          )}
          <div className="row" class="printDiv" ref={componentRef}>
            <div className="well col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="text-center">
                    <div>
                      <Avatar
                        size="xxl"
                        imageURL={cooperative.logo}
                        alt="Cooperative logo"
                      />
                    </div>
                    <h2>Deleted purchases report</h2>
                    <strong>
                      {`From ${format(
                        dateRange[0].startDate,
                        "MMM do y"
                      )} to ${format(dateRange[0].endDate, "MMM do y")}`}
                    </strong>
                  </div>
                  <br />
                  <Table
                    responsive
                    className="card-table table-vcenter text-nowrap"
                    headerItems={[
                      { content: "Item name" },
                      { content: "Quantity" },
                      { content: "Supplier" },
                      { content: "Order No." },
                      { content: "Amount" },
                      { content: "Date created" },
                      { content: "Date deleted" },
                    ]}
                  >
                    <Table.Body>
                      {loading && (
                        <Table.Row>
                          <Table.Col colSpan="6">Loading...</Table.Col>
                        </Table.Row>
                      )}
                      {!loading && purchases.items && !purchases.items.length && (
                        <Table.Row>
                          <Table.Col colSpan="6">No results found</Table.Col>
                        </Table.Row>
                      )}
                      {purchases.items &&
                        purchases.items.map((i) => (
                          <Table.Row>
                            <Table.Col>{i.itemName}</Table.Col>
                            <Table.Col>{i.quantity}</Table.Col>
                            <Table.Col>{i.supplierName}</Table.Col>
                            <Table.Col>{i.orderNumber}</Table.Col>
                            <Table.Col>
                              {formatMoney(i.unitCost * i.quantity)}
                            </Table.Col>
                            <Table.Col>
                              {moment(i.created).format("LLL")}
                            </Table.Col>
                            <Table.Col>
                              {moment(i.created).format("LLL")}
                            </Table.Col>
                          </Table.Row>
                        ))}
                    </Table.Body>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </Modal.Body>
      <Modal.Footer>
        <Button color="danger" icon="x-circle" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeletedPurchases;
